import { Button } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'hooks/hooks';
import { clearPdf } from "reducers/pdf.slice";

import FileModel from "models/FileModel";

const fileDownload = require('js-file-download');

const PdfViewer = () => {

    const selectedPdfs = useAppSelector(x => x.pdfs.selectedPdfs);
    const dispatch = useAppDispatch();

    if (!selectedPdfs) return null;

    const base64ToBlob = (data: string) => {
        const bytes = atob(data);
        let length = bytes.length;
        const out = new Uint8Array(length);

        while (length--) {
            out[length] = bytes.charCodeAt(length);
        }

        return new Blob([out], { type: 'application/pdf' });
    };

    const onDownload = (blob: Blob, fileName: string) => {
        fileDownload(blob, fileName);
    }

    const getPdfView = (selectedPdf: FileModel, blob: Blob, url: string) => {
        return (<div className="d-flex justify-content-center mt-4 mb-4">
            <div className="me-3">
                <Button color="link" className="text-decoration-none" onClick={() => dispatch(clearPdf())}>
                    <FontAwesomeIcon icon='arrow-left-long' className="ms-1 me-2" />
                    Back
                </Button>
            </div>
            <embed src={url} width="100%" height="792px" />
            <div className="ms-2">
                <Button color="primary"
                    className="mb-auto mx-3"
                    onClick={() => onDownload(blob, selectedPdf.name)}>
                    <FontAwesomeIcon icon='download' />
                </Button>
            </div>
        </div>);
    }

    const renderPdfs = () => {
        if (selectedPdfs.length > 1) {
            const pdfViews: JSX.Element[] = [];
            for (let i = 0; i < selectedPdfs.length; i++) {
                const selectedPdf = selectedPdfs[i];
                const blob = base64ToBlob(selectedPdf.file);
                const url = URL.createObjectURL(blob);

                const pdfView = getPdfView(selectedPdf, blob, url);
                pdfViews.push(pdfView);
            }
            return pdfViews;
        } else {
            const selectedPdf = selectedPdfs[0];
            const blob = base64ToBlob(selectedPdf.file);
            const url = URL.createObjectURL(blob);
            return getPdfView(selectedPdf, blob, url);
        }
    }
    return (<>
        {renderPdfs()}
    </>);
}

export default PdfViewer;